export const NAME_START = 'Month';

const isSpreadNameAMonth = (spreadName: string): boolean => spreadName.startsWith(NAME_START);

export default isSpreadNameAMonth;
